import { PublishedTemplatePostInsights } from '@3m5/sm_publish-frontend-api/models/PublishedTemplatePostInsights'

export enum PostingTypes {
  likes = 'likes',
  comments = 'comments',
  shares = 'shares',
  impressions = 'impressions',
  reach = 'reach'
}

export type PostingTypesObj = {
  likes?: boolean
  comments?: boolean
  shares?: boolean
  impressions?: boolean
  reach?: boolean
}

export enum PublishedTemplatePostTypes {
  likes = 'likes',
  comments = 'comments',
  shares = 'shares',
  views = 'views',
  impressionsOrganic = 'impressionsOrganic',
  impressionsPaid = 'impressionsPaid'
}

export enum PageStatTypes {
  fans = 'fans',
  dailyReach = 'dailyReach',
  talkingAboutCount = 'talkingAboutCount',
  pageCalls = 'pageCalls',
  organicReach = 'organicReach',
  paidReach = 'paidReach',
  mediaCount = 'mediaCount',
  followersCount = 'followersCount',
  followsCount = 'followsCount',
  emailContacts = 'emailContacts',
  websiteClicks = 'websiteClicks',
  profileViews = 'profileViews',
}

export type PageStatTypesObj = {
  fans?: boolean
  dailyReach?: boolean
  talkingAboutCount?: boolean
  pageCalls?: boolean
  organicReach?: boolean
  paidReach?: boolean
  mediaCount?: boolean
  followersCount?: boolean
  followsCount?: boolean
  emailContacts?: boolean
  websiteClicks?: boolean
  profileViews?: boolean
}